const DateFormats = {
    ddMMyyyy: 'dd/MM/yyyy',
    MMddyyyy: 'MM/dd/yyyy',
    yyyyMMdd: 'yyyy-MM-dd',
    ddMMMMyyyy: 'dd MMMM yyyy',
    MMMMddyyyy: 'MMMM dd, yyyy'
};

const dayjs = global.dayjs;

const es = global.es; // TODO remove dependency!!!

export default class FormatterFuncs {
    private numDecimalPlaces: number;
    private locale: string|undefined;
    private dateFormat: string;

    constructor(numDecimalPlaces: number, locale: string|undefined, dateFormat: string) {
        if (dateFormat == undefined) {
            throw new Error("dateFormat cannot be undefined");
        }

        this.numDecimalPlaces = numDecimalPlaces;
        this.locale = locale;
        this.dateFormat = dateFormat;

        this.format = this.format.bind(this);
        this.number = this.number.bind(this);
        this.date = this.date.bind(this);
        this.localDate = this.localDate.bind(this);
        this.bool = this.bool.bind(this);
        this.getDateFormat = this.getDateFormat.bind(this);
        this.time = this.time.bind(this);
    }

    /**
     * 
     * @param value 
     * @param type 
     * 
     * @returns 
     */
    format(value: any, type: string) {
        if (value == null || value === "") { // false == "", needs to use === to be sure, using == on null so it's the same as === null || === undefined
            return "";
        }

        if ($.type(value) == "date" || type == "TIMESTAMP") {
            return this.date(value);
        }

        if ($.type(value) == "number" || type == "INTEGER" || type == "DECIMAL") {
            return this.number(value);
        }

        if ($.type(value) == "boolean" || type == "BOOLEAN") {
            return this.bool(value);
        }

        return value + '';
    }

    /**
     * 
     * @param value 
     * @param decimalPlaces 
     * 
     * @returns 
     */
    number(value: any, decimalPlaces?: number) {
        if (value == null) {
            return "";
        }

        if (!decimalPlaces) {
            decimalPlaces = this.numDecimalPlaces;
        }

        value = Number(value);
        let formNumber;
        const localFormat = "#,##0." + Array(decimalPlaces).fill("#").join("");
        if (this.locale) {
            formNumber = $.formatNumber(value, {
                'format' : localFormat,
                'locale' : this.locale
            });
        } else {
            formNumber = value.toLocaleString();
        }

        return formNumber;
    }

    /**
     * 
     * @param value 
     * @param truncateTime 
     * 
     * @returns 
     */
    date(value: string | number | Date | null, truncateTime = false) {
        if (value == null) {
            return "";
        }

        //Date comes a string on ranges
        if (typeof value === 'string') {
            value = parseInt(value);
        }

        if (typeof value === 'number') {
            value = new Date(value);
        }

        if (typeof value.getDate == "function") {
            if (isNaN(value.getTime())) {
                //throw new Error("Invalid Date. value=[" + value + "]");
                // I think the date has just not set by the date widget i.e. is the same as null
                return "";
            }
            value = es.util.date.date2Str(value, false);
            value = this.applyDateFormat(value, truncateTime);
            return value;
        }

        throw new Error("Error formatting date value=[" + value + "]");
    }

    /**
     * 
     * @param value 
     * @param truncateTime 
     * 
     * @returns 
     */
    localDate(value:string|number|Date|null, truncateTime: boolean) {
        if (value == null) {
            return "";
        }

        let dateStr = "";
        if (typeof value === 'string') {
            value = parseInt(value);
        }
        if (typeof value === 'number') {
            value = new Date(value);
        }

        if (typeof value.getDate == "function") {
            dateStr = es.util.date.date2Str(value, true);
        }

        value = this.applyDateFormat(dateStr, truncateTime);
        return value;
    }

    /**
     * 
     * @param value 
     * 
     * @returns 
     */
    bool(value:string|boolean|0|1): string {
        if (value == null) {
            return "";
        }

        if (typeof value === 'string') {
            const v = value.toUpperCase().trim();
            if ((v == '1') || (v == 'TRUE')) {
                value = true;
            } else if ((v == '0') || (v == 'FALSE')) {
                value = false;
            }
        }

        if (value === 0 || value === false) {
            return "False";
        }

        if (value === 1 || value === true) {
            return "True";
        }

        return String(value); // just in case, ensure it's a String
    }

    getDateFormat() {
        return this.dateFormat;
    }

    time(value: number|string): string {
        if (typeof value !== 'number') {
            return value;
        }

        let time = dayjs().startOf("d").add(value, "seconds");
        let timeString = time.format("HH:mm");
        /* TOR9-18290 - Ignore seconds when displaying time
        if (time.second() > 0) {
            timeString = time.format("HH:mm:ss");
        }
        */

        return timeString;
    }

    private applyDateFormat(dateString: string, truncateTime: boolean) {
        const longMonthsInYear = ['January', 'February', 'March', 'April', 'May', 'June',
            'July', 'August', 'September', 'October', 'November', 'December'];
        const yearStr = dateString.substring(0, 4);
        const monthStr = dateString.substring(5, 7);
        const monthIndex = parseInt(monthStr)-1;
        const dayStr = dateString.substring(8, 10);

        let result;
        switch (this.dateFormat) {
            case DateFormats.ddMMyyyy:
                result = dayStr + "/" + monthStr + "/" + yearStr;
                break;
            case DateFormats.MMddyyyy:
                result = monthStr + "/" + dayStr + "/" + yearStr;
                break;
            case DateFormats.yyyyMMdd:
                result = yearStr + "-" + monthStr + "-" + dayStr;
                break;
            case DateFormats.ddMMMMyyyy:
                result = dayStr + " " + longMonthsInYear[monthIndex] + " " + yearStr;
                break;
            case DateFormats.MMMMddyyyy:
                result = longMonthsInYear[monthIndex] + " " + dayStr + ", " + yearStr;
                break;
            default:
                throw new Error("Unsupported date format");

        }

        const timeStr = dateString.substring(11, 19);
        if (!truncateTime && timeStr != "00:00:00") {
            result += " " + timeStr;
        }

        return result;
    }
}
